import getPageTag from './pageTag';

const getSpecs = ({ lang, offerId, folio }) => {
  return [
    getPageTag(lang, offerId, folio),
  ];
};

export default getSpecs;
